import Tinymce from './Tinymce.vue'
export default {
  install: function (Vue) {
    Vue.component('Tinymce', Tinymce)
  }
}